import { render, staticRenderFns } from "./ProfileNavigation.vue?vue&type=template&id=e40def6c&"
import script from "./ProfileNavigation.vue?vue&type=script&lang=js&"
export * from "./ProfileNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports